

export const logMissingOnChange = (componentName: string, name?: string): void => {
  if (process.env.NODE_ENV !== 'test') {
    console.error(`${componentName} ${name} changed, but no onChange provided. Did you forget to make it disabled?`);
  }
}